import { Component, Input } from '@angular/core';

@Component({
  selector: 'label-widget',
  templateUrl: './label-widget.component.html',
  styleUrls: ['./label-widget.component.scss'],
})
export class LabelWidgetComponent {
  @Input() id: number;
  @Input() value: string;
  @Input() min: number;
  @Input() max: string;
  @Input() label: string;
  @Input() required: boolean;
  @Input() readonly: boolean;
  @Input() possibleValues: any;

  
  constructor() {}
}
